module.exports = __webpack_public_path__ + "img/logo_title.ea47440c.png";